import { useQuery } from 'react-query';

import {
  type NewsletterDetailsResponse,
  getRecommendedNewsletters,
} from '@utils/backend-api/newsletters';

const RECOMMENDED_NEWSLETTERS_KEY = 'RECOMMENDED_NEWSLETTERS';

export default function useRecommendedNewsletters() {
  const { data, isLoading } = useQuery<NewsletterDetailsResponse>(
    [RECOMMENDED_NEWSLETTERS_KEY],
    getRecommendedNewsletters
  );

  return { newsletters: data?.newsletters, isLoadingNewsletters: isLoading };
}
